import axios from 'axios'
export const searchAddress = (partialStreet) => {
    return axios({
        url: 'https://api.postgrid.com/v1/addver/completions',
        method: 'get',
        headers: {
            'x-api-key': 'live_pk_bLXjLvw9AwoC52cxey2PYp',
        },
        params: {
            partialStreet,
            
        }
    }).then(res => {
        return res.data
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const getGeoCode = (address) => {
    return axios({
        url: 'https://maps.googleapis.com/maps/api/geocode/json',
        method: 'get',
        params: {
            address,
            key: 'AIzaSyCkSWMpkIDdqYxHPuGER23nY9xDKKkuU1U',
        }
        // data: {
        //     address: {
        //         line1: params.line1,
        //         postalOrZip: params.postalOrZip,
        //         country: params.country
        //     }
        // }
    }).then(res => {
        return res.data.results[0]
    }).catch(err => {
        return Promise.reject(err)
    })
}
